import { render, staticRenderFns } from "./AuthReset.vue?vue&type=template&id=7f4f6f35&"
import script from "./AuthReset.vue?vue&type=script&lang=js&"
export * from "./AuthReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports